import { useEffect } from "react";

// Adds .is-visible class to .reveal elements as they enter the viewport.
// Falls back to a timer so elements always become visible eventually
// (covers headless browsers and edge cases).
export default function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));

    // Immediately reveal elements already on screen (top of page)
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add("is-visible");
      }
    });

    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px 0px 0px" }
    );
    els.forEach((el) => io.observe(el));

    // Safety net: force-reveal after 1.2s regardless
    const timer = setTimeout(() => {
      els.forEach((el) => el.classList.add("is-visible"));
    }, 1200);

    return () => {
      io.disconnect();
      clearTimeout(timer);
    };
  }, []);
}
